import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';

@Component({
  selector: 'app-add-task-checklist',
  templateUrl: './add-task-checklist.component.html',
  styleUrls: ['./add-task-checklist.component.css']
})
export class AddTaskChecklistComponent {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }

  @Input()
  facilityId: number = 0;

  @Input()
  modalRef: NgbModalRef | undefined;

  @Output()
  success = new EventEmitter<boolean>();

  primaryForm = new UntypedFormGroup({
    label: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
    observation: new UntypedFormControl(''),
    email_notification: new UntypedFormControl('', [Validators.email]),
  });

  items: { label: string; evidence_required: boolean }[] = [
    { label: '', evidence_required: false },
  ];

  addItem() {
    this.items.push({ label: '', evidence_required: false });
  }

  removeItem(index: number) {
    this.items.splice(index, 1);
  }

  create() {
    if (this.primaryForm.invalid) {
      if (this.primaryForm.get('email_notification')?.invalid) {
        this.toast.warning('El correo de notificación ingresado no es válido', 'Tenemos un error');
      } else {
        this.toast.warning('Debe ingresar un nombre válido para la lista (mínimo 3 caracteres)', 'Tenemos un error');
      }
      return;
    }
    const validItems = this.items.filter((i) => i.label && i.label.trim().length >= 2);
    if (validItems.length === 0) {
      this.toast.warning('Debe incluir al menos una tarea en la lista', 'Tenemos un error');
      return;
    }
    const data = {
      facility_id: this.facilityId,
      label: this.primaryForm.get('label')?.value,
      observation: this.primaryForm.get('observation')?.value,
      email_notification: this.primaryForm.get('email_notification')?.value,
      items: validItems.map((item, index) => ({
        label: item.label.trim(),
        position: index,
        evidence_required: item.evidence_required,
      })),
    };
    this.api.createTaskChecklist(data).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Gestión de tareas');
        this.success.emit(true);
        if (this.modalRef != null) {
          this.modalRef.close();
        } else {
          this.modal.dismissAll();
        }
      },
      (error) => {
        this.toast.warning(error.error.mistakes, error.error.msg, {
          enableHtml: true,
          closeButton: true,
        });
      }
    );
  }
}
